import React, { useCallback, useState } from 'react'
import { observer } from 'mobx-react'
import { classNames, format } from '@dt/fe-utils'
import { ProductImage, Stepper, Tags } from 'components'
import { cartMobx } from '@mobx/mall'
import { showMsg } from '@utils'
import DiscountTag from '../DiscountTag'
import { MallController } from '@ctrls/mallController'
import './index.scss'

interface IProps {
  cartItem: IViewMallCartItem;
  isGiven?: boolean; // 是否赠送
  index?: number;
  onSelect?: () => void;
  onChangePackCnt?: (cnt: number) => void;
  disabled?: boolean;
}

const CartProductItem: React.FC<IProps> = ({ cartItem, index, isGiven, onSelect, onChangePackCnt, disabled }) => {
  // const isNeedEllipsis: boolean = !!((cartItem.optionStr).zhLength() > 16 || cartItem.offItems?.[0]?.offTip.zhLength() > 16 || cartItem.offItems.length > 1 || (cartItem.optionStr && cartItem.offItems.length))
  const isNeedEllipsis: boolean = !!((cartItem.optionStr).zhLength() > 32)
  const [showDetail, setShowDetail] = useState([])
  // 售罄类型， 3 下架 2 全规格售罄 1 当前规格售罄
  const disableType = disabled ? (cartItem.isOff ? 3 : !cartItem.saleTotalCnt ? 2 : 1) : 0
  /** 重新选择规格 */
  const handleShowDetail = (cartItem) => {
    MallController.showProductScaleModal(cartItem)
  }

  /** 清除售罄商品  */
  const handleRemoveCart = (cartItem) => {
    cartMobx.remove(cartItem.pk)
  }

  /** 修改数量 */
  const handleChangeCnt = useCallback((isAdd: boolean) => {
    if (isAdd) {
      if (cartItem.saleCnt > 0 && cartItem.cnt >= cartItem.saleCnt) {
        showMsg(i18n.t('productdetail.saleOutTips2'))
        return
      }
      cartMobx.add(cartItem.pk)
    } else {
      cartMobx.reduce(cartItem.pk)
    }
  }, [cartItem.cnt])

  /** 规格组件 */
  const OptionModifyNode = ({ cartItem, isNeedEllipsis }: { cartItem: IViewMallCartItem; isNeedEllipsis: boolean }) => {
    return (
      <div
        className='option-modify-offItems'
      >
        <div>
          <span>
            {
              showDetail.includes(cartItem.pk) && !cartItem.optionStr
                ? '' : (<span>{cartItem.optionStr}</span>)
            }
            {isNeedEllipsis && !showDetail.includes(cartItem.pk) ? (
              <i
                className='iconfont icon-zhankai2x'
                data-cypid='optionModify'
                onClick={(e) => {
                  e.stopPropagation()
                  setShowDetail([...showDetail, cartItem.pk])
                }}
              >
              </i>) : null}
          </span>
          {/* {
            cartItem.offItems.map((v, index: number) => {
              return (
                <p className='off-item' key={index}>
                  <i className='iconfont icon-zhekou2x'></i>
                  <span>{v.offTip}</span>
                </p>
              )
            })
          } */}
        </div>
        {
          isNeedEllipsis && showDetail.includes(cartItem.pk) ? (
            <span
              className='item-detail-handle' onClick={(e) => {
                e.stopPropagation()
                setShowDetail(showDetail.filter(v => v !== cartItem.pk))
              }}
            >
              {i18n.t('newCart.hide')}
            </span>
          ) : null
        }
      </div>
    )
  }

  /** 售罄或者下架展示组件 todo下架商品已经筛选掉了 */
  const productStatusNode = () => {
    const disableTxtArr = ['mall.scaleIsSoldout', 'mall.productIsSoldout', 'mall.productIsOff']
    return (
      <div className='product-status-wrap'>
        <span className='status-txt'>{i18n.t(disableTxtArr[disableType - 1])}</span>
        <span className='check-btn' onClick={() => disableType >= 2 ? handleRemoveCart(cartItem) : handleShowDetail(cartItem)}>{i18n.t(disableType >= 2 ? 'mall.clearProduct' : 'mall.reselectScale')}</span>
      </div>
    )
  }
  return (
    <div
      className='mall-cart-product-item'
      key={cartItem.pk}
    >
      <div
        className={classNames('product-info', {
          'disable-cart-items': disabled
        })}
      >
        <div className='item-detail' onClick={() => !disabled && handleShowDetail(cartItem)}>
          <ProductImage color={!cartItem.pic ? cartItem.productNo : ''} type='mall' width={64} imgSrc={cartItem.pic} />
          <div className={`product-name${isNeedEllipsis && !showDetail.includes(cartItem.pk) ? ' need-ellipsis' : ''}`}>
            <strong>{cartItem.name}</strong>
            <OptionModifyNode cartItem={cartItem} isNeedEllipsis={isNeedEllipsis} />
            <div className='product-extra-info'>
              <Tags datas={[...(cartItem.tags || []), ...(cartItem.allergys || [])]} />
            </div>
          </div>
          {
            !disabled ? (
              <div className='product-price'>
                <div className='price' dangerouslySetInnerHTML={{ __html: format.toPriceLittleCurrency(cartItem.actualPrice) }}></div>
                <div className='item-discount'>
                  <DiscountTag offItems={cartItem.offItems} />
                </div>
                {cartItem.actualPrice !== cartItem.totalPrice ? <del dangerouslySetInnerHTML={{ __html: format.toPriceLittleCurrency(cartItem.totalPrice) }}></del> : ''}
                {isGiven ? <span className='cnt'>{i18n.t('newCart.givenCnt', { cnt: cartItem.cnt })}</span> : null}
              </div>
            ) : <></>
          }
        </div>
        {
          !disabled && (
            <div className='item-actions'>
              <Stepper cnt={cartItem.cnt} onChange={handleChangeCnt} />
            </div>
          )
        }
      </div>
      {
        disableType >= 1 && productStatusNode()
      }
    </div>
  )
}

export default observer(CartProductItem)
